import React from "react";
import { Container } from "react-bootstrap";
import shipping from "../../../../Asset/hero-shipping-automation.svg";

const Third = () => {
  return (
    <>
      <section
        className="side-image-box-section"
        style={{ backgroundColor: "var(--white-color)" }}
      >
        <Container>
          <div className="row align-items-center">
            <div className="col-xl-6 col-lg-12 order-2 order-md-1">
              <div className="info-content">
                <div className="title-paragraph">How Automation Helps</div>
                <p>
                  Decreased operating expenses leads to Enhanced worker security
                  with Shorter lead times for factories and Quicker ROI rate.
                  With all of this automation and save in expense the
                  organization is Being able to compete better with Increased
                  output from production while maintaining Manufacturing and
                  quality of parts that are more reliable with very Less
                  environmental impact.
                </p>
                <p>
                  Higher productivity, dependability, availability, improved
                  performance, and lower operating costs are all advantages of
                  automated processes. Making the switch to lights-out
                  operations pays off well. The advantages of automated systems
                  might be a strong incentive to improve service to your
                  customers.
                </p>
                <p>
                  Successfully executing an automation approach requires taking
                  several crucial actions. The first step is to evaluate your
                  requirements and determine which tasks may be automated.
                  Following the identification of these jobs, you must choose
                  the technologies that will be required to automate them. The
                  next step is to create a plan for implementing the new
                  technology and instructing your staff on its use. The results
                  of your automation approach need to be monitored, and any
                  necessary adjustments need to be made.
                </p>
              </div>
            </div>
            <div className="col-xl-6 col-lg-12 order-1 order-md-2">
              <div className="info-img">
                <img alt="infoImage" src={shipping} className="w-100" />
              </div>
            </div>
          </div>
        </Container>
      </section>
    </>
  );
};

export default Third;
